import * as _ from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { transformColor as h } from "../../utilities/transformations.js";
import { grain as E } from "../../helpers/grain.js";
import { getAspectCorrectedCoordinates as B } from "../../utilities/uv.js";
const O = {
  name: "Satin8",
  collection: "satin",
  tags: ["noise", "organic", "flow"],
  props: {
    colorA: {
      type: String,
      default: "#ca2727",
      transform: h,
      description: "The primary color of the effect"
    },
    colorB: {
      type: String,
      default: "#ff2424",
      transform: h,
      description: "The highlight color in the top-right"
    },
    brightness: {
      type: Number,
      default: 1,
      description: "The overall brightness"
    },
    contrast: {
      type: Number,
      default: 0.8,
      description: "The overall contrast, mostly in the darker areas"
    },
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the satin surface motion"
    }
  },
  fragmentNode: (o) => {
    const {
      vec2: n,
      vec4: y,
      mix: u,
      sin: i,
      cos: l,
      time: g,
      uv: c,
      oneMinus: b
    } = _, d = 90, S = 1.5, x = 1, v = c().mul(S), f = (t = n(0), e) => n(
      t.x.mul(i(e)).sub(t.y.mul(l(e))),
      t.x.mul(i(e)).add(t.y.mul(l(e)))
    );
    let s = n(0), r = n(0), a = 7.5, m = v;
    for (let t = 0; t < 10; t++) {
      m = f(m, d), r = f(r, d);
      const e = m.mul(a).add(t).add(r).sub(g.mul(o.speed.uniform.mul(0.2)));
      r = r.add(i(e)), s = s.add(
        l(e).mul(0.5).add(0.5).div(a)
      ), a *= 1.22;
    }
    const p = s.x.add(s.y), A = p.mul(o.brightness.uniform.mul(1.8)).pow(3).add(p.pow(4)).sub(o.contrast.uniform.mul(0.5)).max(0), C = u(
      o.colorA.uniform,
      o.colorB.uniform,
      c().x.mul(c().y).mul(x)
    ), { correctedUV: N } = B(), T = E(0.8)(N);
    return y(
      u(
        o.colorA.uniform.mul(b(o.contrast.uniform.mul(0.5))).sub(T.mul(0.2)),
        C,
        A
      ),
      1
    );
  }
};
export {
  O as componentDefinition,
  O as default
};
